import { render } from "./BlackWithOrangeTextButton.vue?vue&type=template&id=0c2ed272&scoped=true"
import script from "./BlackWithOrangeTextButton.vue?vue&type=script&lang=js"
export * from "./BlackWithOrangeTextButton.vue?vue&type=script&lang=js"

import "./BlackWithOrangeTextButton.vue?vue&type=style&index=0&id=0c2ed272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2ed272"]])

export default __exports__